import { Box, Flex } from '@approvalmax/ui/src/components';
import random from 'lodash/random';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

export const CollapsedWalletLoading = memo(() => {
    return (
        <Box height={52} radius='xsmall' spacing='16 24' color='midnight20'>
            <Flex justifyContent='space-between' alignItems='center'>
                <Skeleton width={90} height={20} />

                <Skeleton width={random(200, 300)} height={20} />
            </Flex>
        </Box>
    );
});
